import { render } from "./CommissionsKpi.vue?vue&type=template&id=6f55b024"
import script from "./CommissionsKpi.vue?vue&type=script&lang=js"
export * from "./CommissionsKpi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__